(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.querySelectorAll('[data-sh-seo-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const copy = button.closest('[data-sh-seo-copy]');

      if (!copy) {
        return;
      }

      const isExpanded = copy.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(isExpanded));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-adore-product-information"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-sh-size-guide-dialog]').forEach((dialog) => {
  if (!(dialog instanceof HTMLDialogElement) || dialog.dataset.shSizeGuideBound === 'true') return;

  dialog.dataset.shSizeGuideBound = 'true';
  const triggers = Array.from(document.querySelectorAll(`[data-sh-size-guide-open][aria-controls="${dialog.id}"]`));
  const closeControls = Array.from(dialog.querySelectorAll('[data-sh-size-guide-close]'));

  const syncExpanded = (expanded) => {
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(expanded)));
  };

  const closeDialog = () => {
    if (dialog.open) dialog.close();
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (!dialog.open) dialog.showModal();
      syncExpanded(true);
    });
  });

  closeControls.forEach((control) => control.addEventListener('click', closeDialog));

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });

  dialog.addEventListener('close', () => syncExpanded(false));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-collabs-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sh-collabs]').forEach((root) => {
    const items = Array.from(root.querySelectorAll('[data-shc-quotes] > span')).map((item) => ({
      text: item.dataset.text,
      by: item.dataset.by
    })).filter((item) => item.text);
    if (items.length < 2) return;
    const text = root.querySelector('[data-shc-quote-text]');
    const by = root.querySelector('[data-shc-quote-by]');
    let index = 0;
    const render = () => {
      text.textContent = items[index].text;
      by.textContent = items[index].by;
    };
    root.querySelector('[data-shc-quote-prev]')?.addEventListener('click', () => {
      index = (index + items.length - 1) % items.length;
      render();
    });
    root.querySelector('[data-shc-quote-next]')?.addEventListener('click', () => {
      index = (index + 1) % items.length;
      render();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
